module.exports = __webpack_public_path__ + "static/black-998113709d8e826d1f93554bdf60a557.png";